import { photoCity } from './photoCity.js';
import { photoRegion } from './photoRegion.js';

export const photoTimeline = (images) => {
  const data = [...images].sort((image, next) => image._crdate - next._crdate || image._id.localeCompare(next._id));
  const named = new Set(data.filter((image) => image.location?.coordinate && (photoCity(image) || photoRegion(image).region || photoRegion(image).country)).map((image) => image._id));
  let previous;
  let next = 0;
  return data.map((image, index) => {
    if (named.has(image._id)) { previous = image; return image; }
    if (next <= index) {
      next = index + 1;
      while (next < data.length && !named.has(data[next]._id)) next++;
    }
    if (!previous || !data[next]) {
      if (!previous && !data[next]) return image;
      const location = previous || data[next];
      const region = photoRegion(location);
      return {
        ...image,
        inferredLocation: `${previous ? 'From' : 'On way to'} ${[...new Set([photoCity(location) || region.region || region.country, region.country].filter(Boolean))].join(', ')}`,
      };
    }
    const before = photoRegion(previous);
    const after = photoRegion(data[next]);
    const beforeCity = photoCity(previous) || before.region || before.country;
    const afterCity = photoCity(data[next]) || after.region || after.country;
    return {
      ...image,
      country: image.country || (before.country === after.country ? before.country : ''),
      region: image.region || (before.country === after.country && before.region === after.region ? before.region : ''),
      inferredLocation: before.country === after.country
        ? `${beforeCity === afterCity ? beforeCity : `${beforeCity} → ${afterCity}`}${before.country ? `, ${before.country}` : ""}`
        : `${[beforeCity, before.country].filter(Boolean).join(', ')} → ${[afterCity, after.country].filter(Boolean).join(', ')}`,
    };
  });
};
